import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import { InstantSearch } from "react-instantsearch";
import { useSearchSessionUiState } from "@/hooks/use-search-session";
import { SearchTransportContext } from "@/hooks/use-searchkit-client";
import { PageFrame } from "@/layouts/page-frame";
import { IndexView } from "./index.view";
import { MembersSearchAdapter } from "./MembersSearchAdapter";
import { useMembersSearch } from "./useMembersSearch";

const MembersIndexPage = () => {
  const { indexName, searchClient, searchTransport } = useMembersSearch();
  // Refinements + pagination survive navigation via the session store. Members
  // has no location/text search — the map viewport is the only filter.
  const { initialUiState, onStateChange } = useSearchSessionUiState("members");

  return (
    <InstantSearch
      future={{ preserveSharedStateOnUnmount: true }}
      indexName={indexName}
      initialUiState={initialUiState}
      onStateChange={onStateChange}
      searchClient={searchClient}
    >
      <SearchTransportContext.Provider value={searchTransport}>
        <PageFrame contentMaxWidth="full" contentPadded={false} footerFullBleed>
          <Head title={t("web.members.index.meta_title")} />
          <IndexView>
            <MembersSearchAdapter />
          </IndexView>
        </PageFrame>
      </SearchTransportContext.Provider>
    </InstantSearch>
  );
};

export default MembersIndexPage;
